import { format, parseISO } from 'date-fns';

const DEFAULT_LOCALE_DATE_FORMAT = 'dd/MM/yyyy - HH:mm';

export default {
  methods: {
    isTaskExpired(content) {
      return !content.config.beforeDeadline;
    },
    isTaskFinished(content) {
      return content.config.allAttemptsCompleted;
    },
    hasAttachment(content) {
      return content.hasFileUpload;
    },
    getValidAttemptText(content) {
      return {
        1 : this.$t('student.task.attemptsTable.validAttempt.biggestGrade'),
        2 : this.$t('student.task.attemptsTable.validAttempt.average'),
        3 : this.$t('student.task.attemptsTable.validAttempt.lastAttempt')
      }[content.retryTypeId];
    },
    parseDate(date) {
      if (!date) {
        return '';
      }

      let parsedDate;

      if (typeof date === 'string' || date instanceof String) {
        parsedDate = parseISO(date);
      }

      return format(parsedDate, DEFAULT_LOCALE_DATE_FORMAT);
    }
  }
};
